import { Plugin } from 'prosemirror-state';
import { ContentNodeWithPos } from 'prosemirror-utils';

import {
  AddMenuHeading1,
  AddMenuHeading2,
  AddMenuHeading3,
  HeadingOne,
  HeadingThree,
  HeadingTwo,
} from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock, setPlaceholder } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        setPlaceholder(editorView, NODE_NAME, (contentNode: ContentNodeWithPos) =>
          t('Lygo:headingPlaceholder', { level: contentNode.node.attrs.level }),
        );

        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.heading1.title') as string,
            description: t('Lygo:Menu.heading1.description') as string,
            attrs: { level: 1 },
            icon: HeadingOne,
            addMenuIcon: AddMenuHeading1,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['text', 'heading 1', 'h1', '1', 'basic'],
            isText: true,
          },
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.heading2.title') as string,
            description: t('Lygo:Menu.heading2.description') as string,
            attrs: { level: 2 },
            icon: HeadingTwo,
            addMenuIcon: AddMenuHeading2,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['text', 'heading 2', 'h2', '2', 'basic'],
            isText: true,
          },
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.heading3.title') as string,
            description: t('Lygo:Menu.heading3.description') as string,
            attrs: { level: 3 },
            icon: HeadingThree,
            addMenuIcon: AddMenuHeading3,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['text', 'heading 3', 'h3', '3', 'basic'],
            isText: true,
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
